import { useLocation } from 'react-router';

import { useHasPermission as useHP } from '../../users/_hooks/use-has-permission';
import type { RoleClaim } from '../../users/_types/role-claim';

interface UseHasPermissionProps {
  roles: RoleClaim[];
}

export function useHasPermission({ roles }: UseHasPermissionProps) {
  const pathname = useLocation()?.pathname;
  const pathBase = pathname.split('/')[1];
  return useHP({ module: pathBase, roles });
}
